import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

// Central Reach migration: creating new EDPN logs in Core has been disabled.
// Flip this flag back to true to re-enable log creation everywhere it is gated.
export const LOG_CREATION_ENABLED: boolean = false;

// Shared message shown wherever a user attempts to create a new log.
export const LOG_CREATION_DISABLED_MESSAGE =
    "Creating new logs is disabled. We've moved to Central Reach.";

// Full-page notice rendered in place of the log-creation forms once creation is disabled.
export const LogCreationDisabled = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center text-center m-auto mt-24 max-w-xl p-8">
            <FontAwesomeIcon className="text-lacblue w-16 h-16 mb-6" icon={solid('circle-info')} />
            <h2 className="text-2xl font-bold text-lacblue mb-3">Log Creation Disabled</h2>
            <p className="text-lg mb-8">{LOG_CREATION_DISABLED_MESSAGE}</p>
            <button
                onClick={() => navigate('/edpn')}
                className="bg-lacblue w-[12rem] h-[3rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-lacblue-600">
                <span className="drop-shadow">Back to Logs</span>
            </button>
        </div>
    );
};
